import { getSalesFailure, getSalesLoaded, getSalesLoading } from '../../selector';
import { useSelector } from 'react-redux';

export const useMetadata = () => ({
  loading: useSelector(getSalesLoading),
  loaded: useSelector(getSalesLoaded),
  failure: useSelector(getSalesFailure),
});
